import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { removeProductDemoDomainQueries } from '~modules/product-demo/product-demo-query-cache';
import { setProductDemoRuntimeUserId } from '~modules/product-demo/product-demo-runtime';
import { productDemoStorage } from '~modules/product-demo/product-demo-storage';
import { useGetUser } from '~modules/user/api/hooks/use-get-user';

export const ProductDemoBootstrap = () => {
  const queryClient = useQueryClient();
  const { data: user } = useGetUser();

  useEffect(() => {
    setProductDemoRuntimeUserId(user?.id ?? null);

    if (user?.id && productDemoStorage.isEnabled(user.id)) {
      removeProductDemoDomainQueries(queryClient);
    }

    return () => setProductDemoRuntimeUserId(null);
  }, [queryClient, user?.id]);

  return null;
};
